<template>
  <div>
    <b-form-group label="E-mail :">
      <b-input-group
        v-for="(email, key) in contacts.emails"
        :key="'email' + key"
        class="group-emails"
      >
        <b-form-input
          class="mt-1"
          v-model="physical_person.contacts.emails[key].value"
          :state="validateState('emails')"
        ></b-form-input>
        <b-input-group-append class="mt-1">
          <b-button
            v-b-tooltip.hover
            title="Remover e-mail"
            variant="danger"
            @click="removeContact('emails', key)"
          >
            <font-awesome-icon icon="trash" />
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-button
        v-b-tooltip.hover
        title="Adicionar campo e-mail"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('emails')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>

    <b-form-group label="Telefones :" v-if="renderContacts">
      <Phone
        v-for="(phone, key) in contacts.phones"
        v-model="physical_person.contacts.phones[key]"
        :key="key"
        ref="phone-values"
        @remove="removeContact('phones', key)"
      />

      <b-button
        v-b-tooltip.hover
        title="Adicionar campo número"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('phones')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>

    <b-form-group label="Mídias Sociais :" v-if="renderContacts">
      <SocialNetwork
        v-for="(social_network, key) in contacts.social_networks"
        v-model="physical_person.contacts.social_networks[key]"
        :key="key"
        ref="social-networks-values"
        @remove="removeContact('social_networks', key)"
      />
      <b-button
        v-b-tooltip.hover
        title="Adicionar campo Mídias Sociais"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('social_networks')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { numeric, email, url } from "vuelidate/lib/validators";
import Phone from "./Contatos/Phone.vue";
import SocialNetwork from "./Contatos/SocialNetwork.vue";

export default {
  components: { Phone, SocialNetwork },
  props: {},
  mixins: [validationMixin],
  data: () => ({
    renderContacts: true,
  }),
  validations: {
    contacts: {
      phones: {
        $each: {
          value: {
            numeric,
          },
        },
      },
      emails: {
        $each: {
          value: {
            email,
          },
        },
      },
      social_networks: {
        $each: {
          value: {
            url,
          },
        },
      },
    },
  },
  computed: {
    ...mapState("physical_people", ["physical_person"]),
    ...mapGetters("physical_people", ["getContactsEmpty"]),
    contacts() {
      return this.physical_person.contacts ? this.physical_person.contacts : {};
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.contacts[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      let valid = true;
      this.$refs["phone-values"].forEach((value) => {
        valid &= value.isValid();
      });

      this.$refs["social-networks-values"].forEach((value) => {
        valid &= value.isValid();
      });

      this.$v.contacts.$touch();
      valid &= !this.$v.contacts.$anyError;
      console.log(this.$v.contacts);
      return valid;
    },
    addContact(type_contact) {
      this.physical_person.contacts[type_contact].push({ value: "" });

      this.renderContacts = false;
      this.$nextTick(() => {
        this.renderContacts = true;
      });
    },
    removeContact(type_contact, index) {
      this.physical_person.contacts[type_contact].splice(index, 1);

      if (this.physical_person.contacts[type_contact].length <= 0) {
        this.addContact(type_contact);
      }
    },
  },
  created() {
    if (!this.physical_person.contacts) {
      this.physical_person.contacts = this.getContactsEmpty;
    }
  },
};
</script>

<style lang="scss" scope>
.social-button {
  width: 40px;

  label {
    width: 100%;
    padding: 0;
    height: 100%;
    display: block;
    background-color: transparent !important;
    border: none !important;
    background-size: 100%;
    filter: grayscale(100%);
    opacity: 0.3;
    transition: all 0.2s;

    :hover {
      background-color: transparent !important;
    }

    &.focus {
      border: none !important;
      box-shadow: none !important;
    }

    &.active {
      filter: grayscale(0%);
      opacity: 1;
    }
  }

  &.linkedin-icon {
    label {
      background-image: url("~@/assets/img/icones/linkedin.png");
    }
  }

  &.facebook-icon {
    label {
      background-image: url("~@/assets/img/icones/facebook.png");
    }
  }

  &.instagram-icon {
    label {
      background-image: url("~@/assets/img/icones/instagram.png");
    }
  }

  &.whatsapp-icon {
    label {
      background-image: url("~@/assets/img/icones/whatsapp.png");
    }
  }

  &.telegram-icon {
    label {
      background-image: url("~@/assets/img/icones/telegram.png");
    }
  }
}
</style>
